import { c as _c } from "react/compiler-runtime";
import Img from '@/components/elements/Img';
const RatingsBannerImage = t0 => {
    const $ = _c(6);
    const { media, className } = t0;
    const url = media?.url;
    const caption = media?.caption ?? "provider image";
    const computedClassName = `relative bg-gray-100 overflow-hidden ${className}`;
    let t1;
    if ($[0] !== caption || $[1] !== url) {
        t1 = url && <Img src={url} alt={caption} sizes={"(max-width: 895px) 100vw,\n            (max-width: 1023px) 272px,\n            288px"} className="w-full h-full object-cover"/>;
        $[0] = caption;
        $[1] = url;
        $[2] = t1;
    }
    else {
        t1 = $[2];
    }
    let t2;
    if ($[3] !== computedClassName || $[4] !== t1) {
        t2 = <div className={computedClassName}>{t1}</div>;
        $[3] = computedClassName;
        $[4] = t1;
        $[5] = t2;
    }
    else {
        t2 = $[5];
    }
    return t2;
};
export default RatingsBannerImage;
